import { planTypes } from '@/common/constants';

export default {
  data() {
    return {
      title: this.$t('billing.video_sdk_uc.free_trial_title'),
      subtitle: '',
      logo: require('@/assets/plans/sdkuc.svg'),
      trackingPlanName: this.$t('billing.video_sdk_uc.free_trial_title'),
      planType: planTypes.VIDEO_SDK_UC,
    };
  },
};
